import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';

import * as InspectionActions from '../../inspection/inspection.actions';
import * as ReportsActions from '../reports.actions';
import { getCurrentUser } from '../../user/user.selectors';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  hide: {
    display: 'none',
  },
});


class WorkorderConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
  };

  render() {
    const { open, workorderInfo } = this.props;
    if (!open) {
      return null;
    }
    const sendTime = workorderInfo.sentAt || 'Tapahtui virhe: tietoa ei löydy'
    const serial = workorderInfo.serialnumber || 'Laitteelle ei ole kirjattu sarjanumeroa'
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        <div>
         <DialogContent>
           <DialogContentText>
            <span>Työtilaus lähetetty:<br />{sendTime}</span>
           </DialogContentText>
           <br />
           <DialogContentText>
            <span>Laitteen sarjanumero:<br />{serial}</span>
           </DialogContentText>
         </DialogContent>
         <DialogActions>
           <Button onClick={this.handleCancel}>Sulje</Button>
         </DialogActions>
       </div>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    Object.assign({}, InspectionActions, ReportsActions)
  )(withStyles(styles)(WorkorderConfirm))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/WorkorderInfo.js